<template>
  <ModalComponent
    name="upload-file"
    class="rouded-full"
    width="500"
    height="700"
    :adaptive="true"
    :click-to-close="false"
    @before-close="files = []"
  >
    <ModalContainer
      title="Upload File"
      @close="hideFileUploadModal"
    >
      <div class="w-full py-4">
        <div>
          <DragDropInput
            :key="componentKey"
            :file-list="files"
            always-active
            @file-dropped="setFile"
          >
            <p class="text-sm leading-relaxed text-center text-slate-600">
              Supported formats: {{ acceptedFileExt.join(", ") }}
              <br>
              NOTE: Data extracted from files larger than {{ fileSizeLimit }}MB
              may be lower in accuracy
            </p>
          </DragDropInput>
          <div class="flex flex-col w-full mt-6 gap-y-2">
            <div
              v-if="duplicateFiles.length"
              class="relative w-full px-4 py-3 border border-red-600 rounded-lg"
            >
              <p
                v-for="filename in duplicateFiles"
                :key="filename"
              >
                Error:
                <span class="text-red-700">{{ filename }} already exists</span>
              </p>
            </div>
            <div class="max-h-[130px] space-y-1 overflow-auto">
              <AttachmentListContainer
                v-for="(file, idx) in files"
                :key="idx"
                :index="idx"
                :file
                :error="validateFile(file)"
                @delete="onAttachmentDelete"
              />
            </div>
            <div
              v-if="files.length"
              class="flex justify-end gap-4 mt-4"
            >
              <GhostButton @click="hideFileUploadModal">
                Cancel
              </GhostButton>
              <PrimaryButton
                :disabled="cantConfirmUpload"
                @click="confirmUpload"
              >
                <span v-if="!progress">Upload & Continue</span>
                <span v-else>Upload in progress... {{ progress }}%</span>
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  </ModalComponent>
</template>

<script>
export default {
  name: 'UploadFileModal',

  props: {
    fileNames: {
      // strings
      type: Array,
      default: () => [],
    },
  },

  emits: ['upload-files'],

  data() {
    return {
      componentKey: 0,
      attachedFileNames: this.fileNames,
      files: [],
      duplicateFiles: [],
      fileSizeMessage: '',
      fileSizeLimit: 20,
      acceptedFileExt: [
        'xls',
        'xlsx',
        'csv',
        'pdf',
        'png',
        'jpg',
        'jpeg',
        'bmp',
      ],
    }
  },

  computed: {
    fileUploadError() {
      return this.files
        .map(file => this.validateFileSize(file))
        .filter(err => err)
    },
    progress() {
      return this.$store.uploadProgress.percentage
    },
    cantConfirmUpload() {
      return !!this.fileUploadError.length || !!this.progress || !!this.duplicateFiles.length
    },
  },

  watch: {
    fileNames(newNames) {
      this.attachedFileNames = newNames
    },
  },

  methods: {
    validateFile(file) {
      return [this.validateFileSize(file)]
    },
    validateFileSize(file) {
      return Number(file.size / 1024 / 1024) > this.fileSizeLimit
        ? `Data extracted from files larger than ${this.fileSizeLimit}MB may be lower in accuracy`
        : null
    },
    hideFileUploadModal() {
      this.files = []
      this.$modal.hide('upload-file')
    },
    setFile(files) {
      this.files = files
      this.checkDuplicateFiles()
    },
    onAttachmentDelete(index) {
      this.files.splice(index, 1)
      this.checkDuplicateFiles()
    },
    confirmUploadOld() {
      this.$parent.$emit('submit', {
        files: this.files,
        modal: this.$parent,
      })
    },
    checkDuplicateFiles() {
      const existingSetOfFiles = [...new Set(this.attachedFileNames)]
      this.duplicateFiles = [...this.files].filter(file => existingSetOfFiles.some(attached => attached && attached.includes && attached.includes(file.name))).map(file => file.name)
    },
    confirmUpload() {
      this.$emit('upload-files', this.files)
    },
  },
}
</script>
